module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.config.title) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.getTitle())),
      expression: "t(getTitle())",
      arg: "tooltip"
    }]
  }, [_vm._v(_vm._s(_vm.getName()))]) : _c('span', [_vm._v(_vm._s(_vm.getName()))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3aa7ce46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/DefaultHeaderComponent.vue
// module id = 1271
// module chunks = 2